<template>
  <div class="overlay" ref="overlay" v-if="display_errors">
    <div class="overlay__bg"></div>
    <div class="overlay__box">
      <div class="close-btn" @click="dismissErrors"></div>
      <h3>Error</h3>
      <p v-html="errorMessage()"></p>
      <div class="overlay__actions">
        <a href="#" @click.prevent="openChat">
          <div class="overlay__chat">
            <div class="overlay__chat__icon"></div>
            <div class="overlay__chat__text">Need Help?</div>
          </div>
        </a>
        <a :href="telephone()">
          <div class="overlay__phone">
            <div class="overlay__phone__icon"></div>
            <div class="overlay__phone__text">Book by Phone</div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['display_errors'],
    methods: {
      dismissErrors() {
        this.$emit('close')
      },
      errorMessage() {
        let { errorFields, errors } = this.$store.state
        errorFields = (typeof errorFields === 'undefined') ? [] : errorFields
        let field = errorFields[0]
        if (typeof field === 'undefined') {
          return Object.values(errors)[0]
        } else {
          return this.fieldMessage(field, errorFields)
        }
      },
      fieldMessage(field, errorFields) {
        if (typeof field.validity === 'undefined') return
        let valueMissing = field.validity.valueMissing
        let subject = field.getAttribute('aria-label').replace('*', '')
        let adjective = valueMissing ? 'blank' : 'invalid'
        if (adjective == 'blank' && field.type == 'checkbox') adjective = 'unchecked'
        let plural = `${subject} and other fields are ${adjective}`
        let singular = `${subject} is ${adjective}`
        return errorFields.length > 1 ? plural : singular
      },
      telephone() {
        return `tel:+1${this.$store.state.app_data.customer_service_phone}`
      },
      openChat() {
        olark('api.box.expand')
      }
    }
  }
</script>

<style scoped>
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 60;
    &__bg {
      position: absolute;
      width: 100%;
      height: 100%;
      opacity: 0.8;
      background-color: #042f5b;
      border: 8px solid #ff8325;
    }

    &__box {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateY(-50%) translateX(-50%);
      background: #fff;
      width: calc(100% - 16px);
      text-align: center;
      padding: 39px 39px 25px 39px;
      color: #042f5b;
      max-width: 500px;

      h3,
      p {
        color: #042f5b;
      }

      h3 {
        font-family: 'Founders Grotesk Cond Lt';
        font-size: 40px;
        font-weight: 300;
        margin: 0 0 30px;
      }

      p {
        font-size: 22px;
        line-height: 1.27;
        letter-spacing: 0.34px;
      }
    }

    &__actions {
      display: flex;
      justify-content: space-between;
      padding: 0;
      margin: 50px 0 0 0;
      a {
        color: #042f5b;
      }
    }

    &__chat,
    &__phone {
      display: flex;
      &__icon {
        height: 24px;
        width: 27px;
        margin: 0 7px 0 0;
        background-size: contain;
        background-repeat: no-repeat;
        filter: brightness(0.4) sepia(1) hue-rotate(180deg) saturate(5);
      }
    }

    &__chat {
      &__icon {
        background-image: url(~icons/chat.svg);
      }
    }

    &__phone {
      &__icon {
        background-image: url(~icons/phone.svg);
      }
    }

    .close-btn {
      position: absolute;
      top: 0;
      right: 0;
      height: 60px;
      width: 60px;
      background: #ff8325;
      &:before {
        position: absolute;
        content: '';
        top: 50%;
        left: 50%;
        height: 15px;
        width: 15px;
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url(~icons/icon-close.svg);
        transform: translateX(-50%) translateY(-50%);
        color: #fff;
      }
    }
  }
</style>
